var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "#4E4E4E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57568 4.77277C6.57568 3.81518 7.352 3.03889 8.30956 3.03889C9.26712 3.03889 10.0434 3.81518 10.0434 4.77277C10.0434 5.40848 9.70129 5.96429 9.1912 6.26613C8.75158 6.52616 8.30956 6.92065 8.30956 7.43139V8.5873"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30926 12.2863C8.81997 12.2863 9.23399 11.8723 9.23399 11.3615C9.23399 10.8508 8.81997 10.4368 8.30926 10.4368C7.79854 10.4368 7.38452 10.8508 7.38452 11.3615C7.38452 11.8723 7.79854 12.2863 8.30926 12.2863Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3025 7.66259C15.3025 10.9589 15.3025 12.6072 14.2784 13.6312C13.2544 14.6553 11.6062 14.6553 8.30981 14.6553C5.01343 14.6553 3.36524 14.6553 2.34119 13.6312C1.31714 12.6072 1.31714 10.9589 1.31714 7.66259C1.31714 4.36621 1.31714 2.71803 2.34119 1.69398C3.36524 0.669922 5.01343 0.669922 8.30981 0.669922C11.6062 0.669922 13.2544 0.669922 14.2784 1.69398C14.9594 2.37488 15.1875 3.33172 15.264 4.86553"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.81662a867227934a6899323be9edd80b.svg";
export { ForwardRef as ReactComponent };